import { render, staticRenderFns } from "./GestioneCorsi.vue?vue&type=template&id=f170f796"
import script from "./GestioneCorsi.vue?vue&type=script&lang=js"
export * from "./GestioneCorsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports